import React from "react";
import { Icon } from "@mui/material";
import { Icon as IconWhatsApp } from "@iconify/react";
import { Icon as IconViber } from "@iconify/react";
import { Icon as IconSkype } from "@iconify/react";

export const getTicketSourceIcon = (src) => {
  if (src === "WEB") return <Icon>language</Icon>;
  else if (src === "PHONE") return <Icon>phone</Icon>;
  else if (src === "MAIL") return <Icon>mail</Icon>;
  else if (src === "SMS") return <Icon>sms</Icon>;
  else if (src === "VIBER")
    return (
      <IconViber
        icon="fa-brands:viber"
        style={{
          color: "#8875F0",
          fontSize: "20px",
          verticalAlign: "bottom",
        }}
      >
        phone
      </IconViber>
    );
  else if (src === "WHATS_APP")
    return (
      <IconWhatsApp
        style={{
          color: "#2ccc47",
          fontSize: "20px",
          verticalAlign: "bottom",
        }}
        icon="fa-brands:whatsapp"
      >
        phone
      </IconWhatsApp>
    );
  else if (src === "SKYPE") {
    return (
      <IconSkype
        icon="fa-brands:skype"
        style={{
          color: "#00aff0",
          fontSize: "20px",
          verticalAlign: "bottom",
        }}
      >
        phone
      </IconSkype>
    );
  } else if (src === "NOTES")
    return <Icon sx={{ color: "#0076ff", fontSize: "20px" }}>note_alt</Icon>;
  else if (src === "OTHER") return <Icon>device_unknown</Icon>;
  else if (src === "AUTOLIST") return <Icon>playlist_add_check_circle</Icon>;
  else return "";
};

export const getTicketStatusColor = (status) => {
  if (status === "PENDING") return "info";
  if (status === "IN_PROGRESS") return "secondary";
  if (status === "APPROVED") return "primary";
  if (status === "REJECTED") return "warning";
  if (status === "DONE") return "success";
  if (status === "CANCELLED") return "error";
  if (status == "ESCALATED") return "info";
  if (status == "NO_SHOW") return "error";
  if (status == "STORNO") return "error";
  if (status == "STORNED") return "warning";
  else return "primary";
};

export const getCommunicationStatusColor = (status, type) => {
  if (type == "agent") {
    if (status === "WAITING_FOR_CUSTOMER") return "default";
    if (status === "RECEIVED_RESPONSE") return "warning";
  } else if (type == "client") {
    if (status === "WAITING_FOR_CUSTOMER") return "warning";
    if (status === "RECEIVED_RESPONSE") return "default";
  } else return "primary";
};

export const getTicketPriorityColor = (priority) => {
  if (priority === "LOW") return "info";
  if (priority === "MEDIUM") return "default";
  if (priority === "HIGH") return "error";
  if (priority === "CRITICAL") return "error";
  else return "primary";
};

export const getPotentialClientStatus = (status) => {
  if (status === "NEW") return "info";
  if (status === "CONTACTED") return "default";
  if (status === "QUALIFIED") return "primary";
  if (status === "UNQUALIFIED") return "secondary";
  if (status === "CUSTOMER") return "success";
  else return "primary";
};

export const getOfferStatusColor = (status) => {
  if (status === "DRAFT") return "info";
  if (status === "PROPOSAL_SENT") return "default";
  else return "primary";
};

export const getOfferItemStatusColor = (status) => {
  if (status === "NEW") return "info";
  if (status === "WON") return "success";
  if (status === "LOST") return "error";
  if (status === "NEGOTIATED") return "primary";
  else return "default";
};

export const getTaskStatusColor = (status) => {
  if (status === "TO_DO") return "info";
  if (status === "DONE") return "success";
  else return "default";
};

export const getTaskPriorityIcon = (priority) => {
  if (priority === "LOW") return "keyboard_double_arrow_down";
  if (priority === "MEDIUM") return "menu";
  if (priority === "HIGH") return "keyboard_double_arrow_up";
};

export const getTaskPriorityIconColor = (priority) => {
  if (priority === "LOW") return "#2684FF";
  if (priority === "MEDIUM") return "#FFAB00";
  if (priority === "HIGH") return "#FF5630";
};

export const getPresentationStatusIcon = (status) => {
  if (status === "CEKA_ODGOVOR") return "schedule";
  if (status === "PRIHVACENO") return "check_circle";
  if (status === "KONTROLA_POTREBNA") return "policy";
  if (status === "KONTROLA_NEPOZNATA") return "help";
  if (status === "ODBIJENO") return "cancel";
  if (status === "NEDOVRSENA_ANALIZA") return "hourglass_bottom";
  if (status === "NEMA_POPISA_POSILJAKA") return "playlist_remove";
  if (status === "NEPOTPUNI_PODACI") return "report_problem";
  if (status === "KONTROLA_ZAVRSENA_ZADRZANO") return "pan_tool";
  if (status === "GRESKA_U_ODGOVORU") return "error";
  if (status === "TIMEOUT") return "timer_off";
  if (status === "PONISTENJE_CEKA_ODGOVOR") return "restore";
  if (status === "PONISTENO") return "cancel_presentation";
  if (status === "PONISTENJE_ODBIJENO") return "block";
  else return "arrow_upward";
};

export const getPresentationStatusIconColor = (status, theme) => {
  if (status === "PRIHVACENO") return theme.palette.success.main;
  if (
    status === "ODBIJENO" ||
    status === "NEMA_POPISA_POSILJAKA" ||
    status === "NEPOTPUNI_PODACI" ||
    status === "GRESKA_U_ODGOVORU" ||
    status === "TIMEOUT" ||
    status === "PONISTENJE_ODBIJENO"
  )
    return theme.palette.error.main;
  if (
    status === "KONTROLA_POTREBNA" ||
    status === "NEDOVRSENA_ANALIZA" ||
    status === "KONTROLA_ZAVRSENA_ZADRZANO"
  )
    return theme.palette.attention.main;
  if (status === "CEKA_ODGOVOR" || status === "PONISTENJE_CEKA_ODGOVOR")
    return theme.palette.info.main;
  if (status === "KONTROLA_NEPOZNATA") return theme.palette.blueGray.main;
  if (status === "PONISTENO") return theme.palette.lightGray.main;
  else return theme.palette.secondary.main;
};

export const getPresentationStatusColor = (status) => {
  if (status === "PRIHVACENO") return "success";
  if (
    status === "ODBIJENO" ||
    status === "NEMA_POPISA_POSILJAKA" ||
    status === "NEPOTPUNI_PODACI" ||
    status === "GRESKA_U_ODGOVORU" ||
    status === "TIMEOUT" ||
    status === "PONISTENJE_ODBIJENO"
  )
    return "error";
  if (
    status === "KONTROLA_POTREBNA" ||
    status === "NEDOVRSENA_ANALIZA" ||
    status === "KONTROLA_ZAVRSENA_ZADRZANO"
  )
    return "warning";
  if (status === "CEKA_ODGOVOR" || status === "PONISTENJE_CEKA_ODGOVOR")
    return "info";
  else return "default";
};

export const VEHICLE_CATEGORY_ICON_RULES = [
  { minLength: 0, maxLength: 6, icon: "airport_shuttle" }, // Van 0-6m
  { minLength: 7, maxLength: 7, icon: "agriculture" }, // Solo tractor 7m
  { minLength: 7, maxLength: 15, icon: "local_shipping" }, // Lorry 7-15m
  { minLength: 15, maxLength: 17, icon: "directions_car_filled" }, // Artic 15-17m
  { minLength: 17, maxLength: 19, icon: "directions_railway" }, // Road train 17-19m
  { minLength: 19, maxLength: Infinity, icon: "train" }, // Train
];

export const UNACCOMPANIED_VEHICLE_CATEGORY_ICON = "rv_hookup";

const vehicleCategoryRangeOverlap = (a, b) =>
  Math.min(a.maxLength, b.maxLength) - Math.max(a.minLength, b.minLength);

export const getVehicleCategoryIconName = (category) => {
  if (category?.isUnaccompanied) return UNACCOMPANIED_VEHICLE_CATEGORY_ICON;

  const minLength = parseFloat(category?.minLength);
  const maxLength = parseFloat(category?.maxLength);
  if (isNaN(minLength) || isNaN(maxLength)) return null;

  const range = { minLength, maxLength };

  const exact = VEHICLE_CATEGORY_ICON_RULES.find(
    (rule) => rule.minLength === minLength && rule.maxLength === maxLength,
  );
  if (exact) return exact.icon;

  const [closest] = VEHICLE_CATEGORY_ICON_RULES.filter(
    (rule) => vehicleCategoryRangeOverlap(rule, range) >= 0,
  ).sort(
    (a, b) =>
      vehicleCategoryRangeOverlap(b, range) -
      vehicleCategoryRangeOverlap(a, range),
  );

  return closest ? closest.icon : null;
};

export const getVehicleCategoryIcon = (category, style) => {
  const icon = getVehicleCategoryIconName(category);
  return icon ? (
    <Icon className="vehicle-icon" style={style}>
      {icon}
    </Icon>
  ) : (
    ""
  );
};
